import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=89d0cb28&scoped=true"
import script from "./insights.vue?vue&type=script&lang=js"
export * from "./insights.vue?vue&type=script&lang=js"
import style0 from "./insights.vue?vue&type=style&index=0&id=89d0cb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0cb28",
  null
  
)

export default component.exports